<template>
  <div class="bto-sb-mb-nav-bar">
    <a @click="goBack"></a>
    <h2>{{title}}</h2>
  </div>
</template>

<script>
  export default {
    name: 'TitleNavbarComponent',
    props: {
      title: {
        type: String,
        default: '',
      },
    },
    methods: {
      goBack() {
        const history = this.$store.state.routeHistoryModule.history;
        this.$store.commit('setGoingBackExplicit');
        if (history.length > 0) {
          this.$router.push(history[history.length - 1].fullPath);
        } else {
          this.$router.push('/');
        }
      },
    },
  };
</script>
